.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: calc(var(--spacer) * 5);
  padding-top: calc(var(--spacer) * 3);
}

.k8s-page-text {
  max-width: 846px;
}

.k8s-page-title {
  padding-bottom: calc(var(--spacer) * 2);
}

#verificationTitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  padding-bottom: calc(var(--spacer) * 4);
}

#downloadInstructions {
  padding-bottom: calc(var(--spacer) * 5);
}

#companyFormField {
  padding-bottom: calc(var(--spacer) * 4);
}

gz-copy-to-clipboard {
  width: 846px;
  height: auto;
  font-size: 11px;
  padding-top: calc(var(--spacer));
}

.text-placeholder {
  border: 1px solid var(--chart-101-pressed-dividers);
  padding: var(--spacer);
  border-radius: var(--widget-border-radius);
  background-color: var(--chart-050-hover);
  white-space: pre;
  width: 100%;
}

.steps-section {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer));
  margin-bottom: calc(var(--spacer) * 5);
}

.inner-steps-section {
  display: flex;
  flex-direction: column;

  ol {
    list-style: lower-alpha;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 1em;
    font-size: var(--font-size);
  }
}
